import { Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';

interface MentorshipTheme {
  month: string;
  year: number;
  title: string;
}

// shortcut: themes are hardcoded in the section component; migrate to a data
// source (API/CMS or a shared domain resource) when the schedule gets a second
// consumer, such as the dashboard, or when monthly edits by a non-developer are
// required.
const MENTORSHIP_THEMES: MentorshipTheme[] = [
  { month: 'Junho', year: 2026, title: 'Desenvolvimento com Agentes de IA' },
  { month: 'Agosto', year: 2026, title: 'Arquitetura em Camadas com Nx' },
  { month: 'Setembro', year: 2026, title: 'Orquestração de Agentes de IA' },
  { month: 'Outubro', year: 2026, title: 'SSR com Angular' },
  { month: 'Novembro', year: 2026, title: 'Micro Frontend com Angular' },
];

@Component({
  selector: 'app-mentorship-schedule',
  imports: [ContentContainer],
  templateUrl: './mentorship-schedule.html',
})
export class MentorshipSchedule {
  protected readonly themes = MENTORSHIP_THEMES;
}
